import { Mail, MessageSquare, Bug } from "lucide-react";

const CONTACT_REASONS = [
  {
    icon: MessageSquare,
    title: "General questions",
    desc: "Questions about how the platform works, what's included in each plan, or how to get started.",
  },
  {
    icon: Bug,
    title: "Bug reports",
    desc: "Found something that doesn't work as expected? Let us know and we'll look into it.",
  },
  {
    icon: Mail,
    title: "Feature requests",
    desc: "Have an idea for something that would make your reporting workflow easier? We're listening.",
  },
];

export default function Contact() {
  return (
    <div className="contact-page">

      {/* ── Header ──────────────────────────────────────────────── */}
      <section className="section-base">
        <div className="section-inner contact-header">
          <div className="section-label">Get in touch</div>
          <h1 className="section-heading" style={{ marginBottom: "1rem" }}>
            We read every message.
          </h1>
          <p className="contact-subhead">
            Questions, bug reports, feedback — send them all to the same place.
            You&apos;ll hear back from a real person, not a bot.
          </p>
          <a href="mailto:contact@easyreports.ca" className="contact-email-link">
            <Mail size={18} />
            contact@easyreports.ca
          </a>
        </div>
      </section>

      {/* ── Reasons ─────────────────────────────────────────────── */}
      <section className="section-alt">
        <div className="section-inner">
          <div className="section-label">What to write about</div>
          <h2 className="section-heading">Reach out for any of the following.</h2>
          <div className="steps-grid">
            {CONTACT_REASONS.map((r) => (
              <div key={r.title} className="step-card">
                <div className="step-icon-wrap">
                  <r.icon size={20} />
                </div>
                <h3 className="step-title">{r.title}</h3>
                <p className="step-desc">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Response note ───────────────────────────────────────── */}
      <section className="section-base">
        <div className="section-inner contact-note-inner">
          <div className="contact-note">
            <span className="section-label" style={{ marginBottom: 0 }}>Response time</span>
            <p className="contact-note-text">
              We typically respond within one business day. During busy reporting
              periods (November and March) it may take a little longer — we
              appreciate your patience.
            </p>
            <a href="mailto:contact@easyreports.ca" className="cta-primary" style={{ width: "fit-content" }}>
              <Mail size={15} />
              Email us now
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
